<template>
  <div class="inline-flex h-[46px] w-[99px] items-start justify-start">
    <div
      class="inline-flex cursor-pointer items-center gap-x-2 rounded-lg border border-gray-200 px-6 py-3 text-sm
        font-semibold text-gray-500 disabled:pointer-events-none disabled:opacity-50"
      :class="`hover:border-${themeColor}-600 hover:text-${themeColor}-600`"
    >
      Ansehen
    </div>
  </div>
</template>
<script setup lang="ts">
  import { useThemeColor } from '@/composables/useThemeColor'
  import { computed } from 'vue'

  const themeColor = computed(() => useThemeColor().value)
</script>
